import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { competitorQuerySchema } from './competitor-query-schema';

export const competitorFormSchema = competitorQuerySchema
  .pick({
    id: true,
    name: true,
    logo: true,
    addresses: true,
    primary_contact: true,
    phone_numbers: true,
    ceo_contact: true,
    associated_clients: true,
    behavior: true,
    current_web_clients: true,
  })
  .extend({
    status: statusFormSchema,
    business_tagline: z.string(),
    founded_date: z.string(),
    email: z.string(),
    website: z.string(),
    pricing_strategy: z.string(),
    tidbits: z.string(),
    weaknesses: z.string(),
    strengths: z.string(),
    how_to_win: z.string(),
    glassdoor_url: z.string(),

    number_of_customers: z.number().nullable(),
    headcount: z.number().nullable(),
    associated_clients_count: z.string().nullable(),
    primary_contact_count: z.string().nullable(),
  });

export type CompetitorFormSchema = z.infer<typeof competitorFormSchema>;
